import React from 'react';

import {useUnit} from 'effector-react';

import {$subscriptionPending, $subscriptionStatus} from '@/entities/subscriptions/model';
import {SubscriptionStatusEnum} from '@/entities/subscriptions/types';
import {Page} from '@shared/ui/Page';
import {Spinner} from '@shared/ui/Spinner';

import {ActiveSubscriptionPage} from './ActiveSubscription';

import {PaywallPage} from './Paywall';
import * as S from './styled';

export const SubscriptionsPage = () => {
    const subscriptionStatus = useUnit($subscriptionStatus);
    const isLoading = useUnit($subscriptionPending);

    if (isLoading || !subscriptionStatus) {
        return (
            <Page>
                <S.LoadingWrap>
                    <Spinner size={3} color="primary" />
                </S.LoadingWrap>
            </Page>
        );
    }
    return (
        <Page>
            {subscriptionStatus.status !== SubscriptionStatusEnum.INACTIVE ? (
                <ActiveSubscriptionPage status={subscriptionStatus} />
            ) : (
                <PaywallPage />
            )}
        </Page>
    );
};
